import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
import { FIRM } from '../../lib/constants';
import { Container } from '../ui/Container';
const serviceLinks = [{
  label: 'Commercial & Business Law',
  href: '/services/commercial-business-law'
}, {
  label: 'Dispute Resolution & Litigation',
  href: '/services/dispute-resolution'
}, {
  label: 'Property Law',
  href: '/services/property-law'
}, {
  label: 'Conveyancing & Settlements',
  href: '/services/conveyancing'
}, {
  label: 'Family Law',
  href: '/services/family-law'
}, {
  label: 'Wills, Estates & Succession',
  href: '/services/wills-estates'
}, {
  label: 'Franchising Law',
  href: '/services/franchising'
}, {
  label: 'Employment & Workplace',
  href: '/services/employment'
}];
const resourceLinks = [{
  label: 'Legal Guides',
  href: '/#guides'
}, {
  label: 'FAQs',
  href: '/#faq'
}, {
  label: 'What to Expect',
  href: '/#process'
}, {
  label: 'Fees & How We Charge',
  href: '/#faq'
}, {
  label: 'Make an Enquiry',
  href: '/enquiry'
}];
export function Footer() {
  return <footer className="bg-navy text-cream" data-id="element-233">
      <Container className="grid grid-cols-1 gap-10 py-14 md:grid-cols-2 lg:grid-cols-12 lg:gap-8" data-id="element-234">
        {/* brand + contact */}
        <div className="lg:col-span-4" data-id="element-235">
          <div className="inline-flex rounded-lg bg-cream px-4 py-3" data-id="element-236">
            <img src={FIRM.logo} alt={FIRM.name} className="h-8 w-auto" data-id="element-237" />
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-cream/70" data-id="element-238">
            {FIRM.positioning}
          </p>
          <ul className="mt-6 space-y-3 text-sm text-cream/80" data-id="element-239">
            <li className="flex items-start gap-3" data-id="element-240">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brass-light" data-id="element-241" />
              <span data-id="element-242">
                {FIRM.addressLine1}
                <br data-id="element-243" />
                {FIRM.addressLine2}
              </span>
            </li>
            <li className="flex items-center gap-3" data-id="element-244">
              <PhoneIcon className="h-4 w-4 shrink-0 text-brass-light" data-id="element-245" />
              <a href={FIRM.phoneHref} className="hover:text-brass-light" data-id="element-246">
                {FIRM.phoneDisplay}
              </a>
            </li>
            <li className="flex items-center gap-3" data-id="element-247">
              <MailIcon className="h-4 w-4 shrink-0 text-brass-light" data-id="element-248" />
              <a href={FIRM.emailHref} className="hover:text-brass-light" data-id="element-249">
                {FIRM.email}
              </a>
            </li>
            <li className="flex items-center gap-3" data-id="element-250">
              <ClockIcon className="h-4 w-4 shrink-0 text-brass-light" data-id="element-251" />
              <span data-id="element-252">Mon–Fri, 8:30am–5:00pm AWST</span>
            </li>
          </ul>
        </div>

        {/* services */}
        <div className="lg:col-span-4" data-id="element-253">
          <h3 className="text-xs font-semibold uppercase tracking-[0.16em] text-brass-light" data-id="element-254">
            Legal Services
          </h3>
          <ul className="mt-5 grid grid-cols-1 gap-x-6 gap-y-2.5 text-sm sm:grid-cols-2" data-id="element-255">
            {serviceLinks.map(s => <li key={s.label} data-id="element-256">
                <Link to={s.href} className="text-cream/75 transition-colors hover:text-brass-light" data-id="element-257">
                  {s.label}
                </Link>
              </li>)}
          </ul>
        </div>

        {/* resources + trust */}
        <div className="lg:col-span-4" data-id="element-258">
          <h3 className="text-xs font-semibold uppercase tracking-[0.16em] text-brass-light" data-id="element-259">
            Resources & Contact
          </h3>
          <ul className="mt-5 space-y-2.5 text-sm" data-id="element-260">
            {resourceLinks.map(r => <li key={r.label} data-id="element-261">
                {r.href.startsWith('/enquiry') ? <Link to={r.href} className="text-cream/75 transition-colors hover:text-brass-light" data-id="element-262">
                    {r.label}
                  </Link> : <a href={r.href} className="text-cream/75 transition-colors hover:text-brass-light" data-id="element-263">
                    {r.label}
                  </a>}
              </li>)}
          </ul>
          <div className="mt-6 flex items-start gap-3 rounded-lg border border-cream/10 bg-navy-800 p-4" data-id="element-264">
            <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage-light" data-id="element-265" />
            <p className="text-xs leading-relaxed text-cream/65" data-id="element-266">
              Enquiries are confidential and directed to the most appropriate
              team. Contacting us does not create a lawyer–client relationship.
            </p>
          </div>
        </div>
      </Container>

      <div className="border-t border-cream/10" data-id="element-267">
        <Container className="flex flex-col items-center justify-between gap-3 py-6 text-xs text-cream/55 sm:flex-row" data-id="element-268">
          <p data-id="element-269">
            © {new Date().getFullYear()} {FIRM.name}. All rights reserved.
          </p>
          <p className="text-center sm:text-right" data-id="element-270">
            Nedlands · Perth · Western Australia — proudly serving WA business,
            families and property owners.
          </p>
        </Container>
      </div>
    </footer>;
}